// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import Highlighter from "react-highlight-words";
import { Button, LocaleLink } from "../../common";
import Actions from "../../../actions/Creators";
import Helper from "../../../helper/Helper";
import I18n from "../../../i18n/I18n";
import styles from "./ItemNumber.scss";

class AsnRow extends Component {
  state = {
    orderNav: true,
    itemNr: null
  };
  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.orders !== prevProps.orders &&
      !this.props.orders.isSingleLoading &&
      this.state.orderNav &&
      this.props.itemNr === this.state.itemNr
    ) {
      this.setState({
        orderNav: false
      });
      if (
        this.props.orders &&
        this.props.orders.singleOrder &&
        this.props.seller &&
        this.props.orders.singleOrder.orders
      ) {
        const { tab } = this.props.orders.singleOrder.orders[0];
        const statusNr = Helper.getStatusNr(
          tab,
          this.props.seller.is_fm_pickup
        );
        this.props.history.push(
          `/${Helper.getLocale()}/orders?search=${
            this.state.itemNr
          }&status=${statusNr}`
        );
      }
    }
  }

  orderNav = item_nr => {
    this.props.getOrderDetails(item_nr);
  };

  getOrderDetails = item_nr => {
    let query = `item_nr=${item_nr}`;
    this.props.dispatch(Actions.getSingleOrder(query));
    const newState = {};
    newState.orderNav = true;
    newState.itemNr = item_nr;
    this.setState(newState);
  };

  render() {
    const {
      lang,
      orders,
      itemNr,
      button,
      searchString,
      seller,
      isNoonUser
    } = this.props;
    const stockRequestAllowed = seller.is_allow_stock_request || isNoonUser;
    if (button)
      return (
        <a
          target="_blank"
          href={`/${Helper.getLocale()}/${
            stockRequestAllowed ? `sales/${itemNr}` : `orders?item_nr=${itemNr}`
          }`}
        >
          <Button
            variant="dashed"
            className={styles.button}
            // onClick={() => this.getOrderDetails(itemNr)}
          >
            {I18n.getText("transfers.accepted-item")}
          </Button>
        </a>
      );
    else
      return (
        <a
          className={styles.itemNr}
          target="_blank"
          href={`/${Helper.getLocale()}/${
            stockRequestAllowed ? `sales/${itemNr}` : `orders?item_nr=${itemNr}`
          }`}
          // onClick={() => this.getOrderDetails(itemNr)}
        >
          {itemNr ? (
            <Highlighter
              highlightClassName={styles.highlight}
              searchWords={[searchString]}
              autoEscape={true}
              textToHighlight={itemNr}
            />
          ) : (
            ""
          )}
        </a>
      );
  }
}

const mapStateToProps = state => ({
  orders: state.orders,
  isNoonUser: state.session.isNoonUser,
  seller: state.session.seller
});

export default connect(mapStateToProps)(AsnRow);



// WEBPACK FOOTER //
// ./src/components/orders/itemNumber/ItemNumber.js